import * as StoreTypes from "../DataTypes/storeTypes";
import * as ActionGenerics from "../../Common/actionGenerics";
import * as ActionTypes from "../Actions/actionTypes";
import * as ServiceTypes from "../DataTypes/serviceTypes";

export const servicesData = (
    state: ServiceTypes.IServicesData,
    action: ActionGenerics.IAction<ActionTypes.Actions>
): ServiceTypes.IServicesData => {
    switch (action.type) {
        case ActionTypes.Actions.UpdateServices: {
            const data = action as ActionGenerics.IParamAction<ActionTypes.Actions, ServiceTypes.IServicesData>;

            return data.parameter;
        }

        default:
            return state;
    }
};
